import { getJson } from 'utils/http';

import { ApiGradProgram } from './types/ApiGradProgram';

export function apiFetchGradProgram(
  programId: string,
): Promise<ApiGradProgram> {
  return getJson(`/data/website/grad-programs/${programId}`).then(
    // @ts-expect-error TS(2345): Argument of type '({ data, gradProgram }: { data: ... Remove this comment to see the full error message
    ({ data, gradProgram }) => data || gradProgram,
  );
}
